/**
* VariableMutation.js
* 
* Created on Oct 3, 2013, 3:21:48 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/


export default class VariableMutation {
    constructor(variableName, mutationType, value) {
        this.variableName = variableName;
        this.mutationType = mutationType;
        this.value = value;
    }
}

VariableMutation.ADD = 0;
VariableMutation.SET = 1;
VariableMutation.SUBTRACT = 2;
VariableMutation.MULTIPLY = 3;
VariableMutation.DIVIDE = 4;

